import type { TDT } from "@src/types";

export const getEntityLink = (entityType: string, entityId: number): string => {
  switch (entityType) {
    case "backtest":
      return `/backtest/${entityId}`;
    case "optimization":
      return `/study/${entityId}`;
    // A cache job's created entity is the execution it cached, so it lands on the execution page.
    case "cache":
    case "live":
    case "execution":
      return `/execution/${entityId}`;
    default:
      return `/${entityType}/${entityId}`;
  }
};

/** What `getJobCreatedEntityId` returns for a job type, for labelling the link to it. */
export const getJobCreatedEntityLabel = (jobType: string): string => {
  switch (jobType) {
    case "optimization":
      return "study";
    case "live":
    case "cache":
      return "execution";
    default:
      return jobType;
  }
};

/**
 * Extract entity ID from a completed job's result based on job type
 * Returns entity ID or null if no entity was created
 * Defensive: handles cases where backend hasn't been updated yet
 */
export const getJobCreatedEntityId = (job: TDT.ApiJob): number | null => {
  if (job.status_name !== "completed") return null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = job.result?.data as Record<string, any> | undefined;
  if (!data) return null;

  switch (job.job_type_name) {
    case "backtest":
      return data.backtest_id ?? null;
    case "optimization":
      return data.study_id ?? null;
    case "live":
    case "cache":
      return data.execution_id ?? null;
    default:
      return null;
  }
};
